import {
  allConditionalSteps,
  getStepNamesAccordingToChoices,
  notQuestionSteps,
} from 'config/steps';
import { FlowChoiceType } from 'features/utils/types';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { StepParamsSelector } from 'store/selectors';

export default function useAmountSteps(currentRoute: string) {
  const stepParams = useSelector(StepParamsSelector);
  const amountStepsComplex = useMemo(() => {
    const steps = getStepNamesAccordingToChoices(allConditionalSteps, {
      ...stepParams,
      flowComplexity: FlowChoiceType.COMPLEX,
    });
    const currentStepIndex = steps.indexOf(currentRoute);
    // NOTE: To get the amount of questions in the flow: We take the total steps in the users' flow.
    // We subtract the steps that are not questions, such as the "thanks" page or the summary page.
    // We also subtract the steps that we have already passes (the current step index + 1).
    // that gives us the amount of questions left in the flow.
    return steps.length - (currentStepIndex + 1) - notQuestionSteps.length;
  }, [stepParams, currentRoute]);
  const amountStepsSimple = useMemo(() => {
    const steps = getStepNamesAccordingToChoices(allConditionalSteps, {
      ...stepParams,
      flowComplexity: FlowChoiceType.SIMPLE,
    });
    const currentStepIndex = steps.indexOf(currentRoute);
    return steps.length - (currentStepIndex + 1) - notQuestionSteps.length;
  }, [stepParams, currentRoute]);

  return {
    amountStepsComplex,
    amountStepsSimple,
  };
}
